import { z } from 'zod';

const configSchema = z.object({
  apiUrl: z.string().url(),
  posthogKey: z.string().optional(),
  posthogHost: z.string().url().default('https://app.posthog.com'),
  env: z.enum(['development', 'production', 'test']).default('development'),
  appVersion: z.string().default('0.0.1'),
});

const env = {
  // Use || to handle empty string "" (which ?? would not catch)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_POSTHOG_HOST,
  env: import.meta.env.VITE_ENV ?? 'development',
  appVersion: import.meta.env.VITE_APP_VERSION,
};

const parsed = configSchema.safeParse(env);

if (!parsed.success) {
  console.error('❌ Invalid environment variables:', parsed.error.format());
  throw new Error('Invalid environment variables');
}

export const config = parsed.data;
